import apiClient from './apiClient';

export const createCheckout = async (optionId) => {
  const response = await apiClient.post('/payments/checkout', { optionId });

  return response.data;
};

export const changeSubscription = async (optionId) => {
  const response = await apiClient.patch('/payments/subscription', { optionId });

  return response.data;
};

export const cancelSubscription = async () => {
  const response = await apiClient.post('/payments/subscription/cancel');

  return response.data;
};

export const resumeSubscription = async () => {
  const response = await apiClient.post('/payments/subscription/resume');

  return response.data;
};
